import { makeStyles, Theme } from '@freighthub/silhouette-core'
import { head, last } from 'lodash-es'
import { FC } from 'react'
import { useI18n } from 'utils/localisation'

import { IShipTpEvent } from '../domain/TransportPlanEvent'
import { getDelayTooltip } from '../service/TpDelayTooltip'
import { getTimestampDelayType, TDelayType } from '../service/TransportPlan2'
import { getTpEventsSortedByDelay } from '../service/transportPlanEventUtils'
import { DelayString } from './TpDelayString'
import { SingleDelayStringAndReason } from './TpSingleDelayStringAndReason'
import { TwoDelaysStringAndReason } from './TpTwoDelaysStringAndReason'

const useStyles = makeStyles<Theme>((theme) => ({
  delayRedString: {
    color: theme.palette.status.error,
  },
  delayGreenString: {
    color: theme.palette.status.success,
  },
}))

export const getColorClass = (delayType: TDelayType, isZero: boolean): string => {
  if (isZero) {
    return ''
  }
  return delayType === 1 ? 'delayRedString' : 'delayGreenString'
}

export const useDelayViewData = (delay: number): DelayViewData => {
  const classes = useStyles()
  const { current } = useI18n()
  const { delayType, isZero } = getTimestampDelayType(delay)
  const colorClass: string = classes[getColorClass(delayType, isZero)]
  const delayString =
    (isZero ? '' : delayType === 1 ? '+' : '-') +
    (isZero ? 0 : Math.floor(Math.abs(delay))) +
    (current === 'de' ? 't' : 'd')

  return { colorClass, delayString, isZero }
}

interface EventDelayProps {
  event: IShipTpEvent
}
export const EventDelay: FC<EventDelayProps> = ({ event }) => {
  if (!event) {
    return null
  }
  // @ts-expect-error TS(2339) FIXME: Property 'delay' does not exist on type 'ITimestam... Remove this comment to see the full error message
  const { delay } = event.aggregatedTimestamp
  const delayData = useDelayViewData(delay)
  if (delayData.isZero) {
    return null
  }

  return (
    <DelayString
      // @ts-expect-error TS(2322) FIXME: Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
      colorClass={delayData.colorClass}
      delayString={delayData.delayString}
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      initialDate={event.revisedTimestamp.date}
    />
  )
}

export interface DelayViewData {
  delayString: string
  colorClass?: string
  isZero?: boolean
}

interface EventsDelaysRangeProps {
  events: IShipTpEvent[]
}

interface UseEventDelayRangeProps {
  reason: string
  initialDate: string
  biggestDelayData: DelayViewData
  smallestDelayData: DelayViewData
  isSame: boolean
}

const useEventsDelayRange = (events: IShipTpEvent[]): UseEventDelayRangeProps => {
  const eventsSortedByDelay = getTpEventsSortedByDelay(events)

  const biggestDelayEvent = head(eventsSortedByDelay)
  const smallestDelayEvent = eventsSortedByDelay.length > 1 && last(eventsSortedByDelay)

  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const biggestDelayStamp = biggestDelayEvent.aggregatedTimestamp
  const smallestDelayStamp = smallestDelayEvent && smallestDelayEvent.aggregatedTimestamp

  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const biggestDelay = biggestDelayStamp.delay
  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const smallestDelay = smallestDelayStamp.delay
  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const biggestDelayReason = biggestDelayStamp.reason
  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const smallestDelayReason = smallestDelayStamp.reason

  return {
    reason: biggestDelayReason || smallestDelayReason,
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    initialDate: biggestDelayEvent.revisedTimestamp.date,
    // @ts-expect-error TS(2345) FIXME: Argument of type 'number | undefined' is not assig... Remove this comment to see the full error message
    biggestDelayData: useDelayViewData(biggestDelay),
    smallestDelayData: useDelayViewData(smallestDelay),
    isSame: biggestDelay === smallestDelay,
  }
}

export const EventsDelaysRange: FC<EventsDelaysRangeProps> = ({ events }) => {
  const { translate } = useI18n()
  const { reason, initialDate, biggestDelayData, smallestDelayData, isSame } = useEventsDelayRange(events)

  if (isSame) {
    if (!biggestDelayData.delayString || biggestDelayData.isZero) {
      return null
    }
    return (
      <SingleDelayStringAndReason
        // @ts-expect-error TS(2322) FIXME: Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
        colorClass={biggestDelayData.colorClass}
        delayString={biggestDelayData.delayString}
        initialDate={initialDate}
        reason={reason}
      />
    )
  }
  return (
    <TwoDelaysStringAndReason
      smallestDelayData={smallestDelayData}
      biggestDelayData={biggestDelayData}
      reason={reason}
      tooltip={getDelayTooltip(translate, initialDate)}
    />
  )
}
